var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2605 13.1567C8.11409 13.1567 8.95932 12.9886 9.74794 12.662C10.5366 12.3353 11.2531 11.8565 11.8567 11.2529C12.4603 10.6494 12.9391 9.9328 13.2657 9.14418C13.5924 8.35556 13.7605 7.51033 13.7605 6.65674C13.7605 5.80315 13.5924 4.95791 13.2657 4.1693C12.9391 3.38068 12.4603 2.66412 11.8567 2.06054C11.2531 1.45696 10.5366 0.978177 9.74794 0.651521C8.95932 0.324866 8.11409 0.156738 7.2605 0.156738C5.53659 0.156738 3.88329 0.841558 2.6643 2.06054C1.44532 3.27953 0.760498 4.93283 0.760498 6.65674C0.760498 8.38065 1.44532 10.0339 2.6643 11.2529C3.88329 12.4719 5.53659 13.1567 7.2605 13.1567ZM7.09294 9.28563L10.7041 4.95229L9.59472 4.02785L6.48916 7.75379L4.88222 6.14613L3.861 7.16735L6.02766 9.33402L6.58666 9.89302L7.09294 9.28563Z",
    fill: "#05AF6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.09bb9627af50c1788ad569c6f5a961c6.svg";
export { ForwardRef as ReactComponent };